const ar = {
  // Navigation
  nav_logo: "CHIEF",
  nav_what_is: "ما هو Chief؟",
  nav_what_does: "ماذا يفعل؟",
  nav_who_for: "لمن هو؟",
  nav_talk: "تحدث مع Chief",
  nav_home: "الصفحة الرئيسية",
  nav_partnership: "نموذج الشراكة",

  // Hero
  hero_title_1:
    "المساعد الذكي الذي يقرأ بياناتك، يجيب على أسئلتك، ويُنجز سير العمل",
  hero_title_2: "بالذكاء الاصطناعي",
  hero_desc:
    "يقرأ Chief البيانات من CRM وERP وExcel وSQL فورًا. يجيب على أسئلتك عبر WhatsApp أو Telegram أو روبوت محادثة مخصص؛ يراقب التغييرات، يُنشئ التنبيهات ويبدأ سير العمل تلقائيًا. Chief يخطط ويتابع ويُكمل العملية بالكامل نيابةً عنك.",
  hero_cta: "تحدث مع Chief",

  // How it works
  how_title_1: "كيف يعمل",
  how_title_2: "Chief؟",
  how_desc:
    "Chief، مساعد الأعمال بالذكاء الاصطناعي، يدير المسار من مصادر بياناتك إلى سير العمل.",
  how_footer: "من Excel إلى ERP، كل بياناتك في متناول Chief",

  // Data Sources
  data_crm: "CRM",
  data_erp: "ERP",
  data_excel: "Excel",
  data_sql: "SQL",
  data_memory: "الذاكرة المؤسسية",

  // Outputs
  output_qa: "سؤال - جواب",
  output_notification: "تنبيهات - إشعارات",
  output_action: "تنفيذ الإجراءات",

  // Workflow
  workflow_title: "مساعد الذكاء الاصطناعي الذي يدير سير العمل",
  workflow_desc_1: "Chief ليس مجرد نظام تحليلي.",
  workflow_desc_2:
    "تطرح السؤال وتحصل على الإجابة؛ وتتقدم العمليات تلقائيًا.",
  workflow_desc_3: "تذهب المهام الصحيحة إلى الأشخاص المناسبين في الوقت المناسب.",
  workflow_desc_4: "تعمل الفرق دون انتظار؛ ولا تتعطل العمليات.",
  workflow_footer:
    "Chief يوجّه جميع المهام تلقائيًا إلى الشخص المناسب حسب سير العمل.",

  // Advantages
  advantage_time_title: "يوفر الوقت",
  advantage_time_desc:
    "يُزيل عبء المتابعة اليدوية. تتقدم سير العمل تلقائيًا. تنخفض مدة التقارير والموافقات بشكل كبير.",
  advantage_error_title: "عمليات خالية من الأخطاء",
  advantage_error_desc:
    "يمنع أخطاء إدخال البيانات. جميع الفرق تعمل بالدقة نفسها وبمعلومات محدثة.",
  advantage_transparent_title: "عمليات شفافة",
  advantage_transparent_desc:
    "كل مهمة، وكل موافقة، وكل تقرير قابل للتتبع. الفرق والإدارة يمكنهم الوصول للمعلومات الآنية دائمًا.",

  // Teams
  teams_title: "Chief هو مساعد حقيقي لجميع الفرق",
  teams_desc:
    "يعرف احتياجات كل دور. يوجّه العمل للوحدة المناسبة وللشخص المناسب. يدير Chief سير العمل بالكامل تلقائيًا في الخلفية.",

  role_clevel_title: "تحكم استراتيجي",
  role_clevel_desc:
    "وصول فوري إلى مؤشرات الأداء دون انتظار التقارير. تُتخذ قرارات المخاطر والربحية ببيانات لحظية.",
  role_manager_title: "إدارة أداء الفريق",
  role_manager_desc:
    "يوازن عبء العمل، يمنع التأخير، وتتم الموافقات تلقائيًا.",
  role_operation_title: "إدارة عمليات سلسة",
  role_operation_desc:
    "تدخل المهام للتنفيذ في الفريق الصحيح بالتسلسل الصحيح. الاتصال بين الميدان والمقر يعمل بسلاسة.",
  role_sales_title: "مزيد من العروض ومزيد من الإيرادات",
  role_sales_desc:
    "مهام تلقائية لفرق المبيعات. يتم إعداد العروض وتتبعها في الوقت المناسب.",
  role_marketing_title: "حملات متصلة بالعمليات",
  role_marketing_desc:
    "التجزئة، الرؤى، وتحركات العملاء تجتمع في ذاكرة واحدة بالذكاء الاصطناعي.",
  role_support_title: "حلول أسرع",
  role_support_desc:
    "تتحول الشكاوى والطلبات إلى مهام تُرسل لوحدات الأعمال. تزداد الرضا وينخفض فقد العملاء.",

  animation_title: "Chief يوجّه المهام وينجز العمل.",

  // Partner Section
  partner_section_title: "كن شريكًا لـ Chief",
  partner_section_desc:
    "ضع Chief بجانب حلولك وقدم لعملائك مساعد قرار مدعوم بالذكاء الاصطناعي. نمُ معًا من خلال مشاركة الإيرادات ودعم التكامل والتسويق المشترك.",

  partner_tech_title: "شركاء التكنولوجيا والتكامل",
  partner_tech_desc:
    "ادمج Chief داخل ERP وCRM وBI وبرامجك المخصصة لتقديم حلول تحليل وقرارات متكاملة.",

  partner_consulting_title: "شركات الاستشارات والتحول الرقمي",
  partner_consulting_desc:
    "استخدم Chief كأداة أساسية في مشاريع التحليل والبيانات والتحول الرقمي.",

  partner_saas_title: "مالكو SaaS والمنتجات",
  partner_saas_desc:
    "أضف طبقة ذكاء اصطناعي لمنتجاتك. Chief يجعلها أكثر ذكاءً عبر القراءة والتحليل وتفعيل الإجراءات.",

  partner_cta_desc: "استكشف نموذج الشراكة والتفاصيل.",
  partner_cta_button: "نموذج الشراكة",

  // Footer
  footer_desc:
    "Chief هو مساعد أعمال بالذكاء الاصطناعي طورته Datafors. يقرأ بيانات مؤسستك، ويؤتمت سير العمل، ويمكّن الفرق من العمل بسرعة وبدون أخطاء.",
  footer_links_title: "روابط",
  footer_link_what: "ما هو Chief؟",
  footer_link_what_does: "ماذا يفعل؟",
  footer_link_who: "لمن هو؟",
  footer_link_partnership: "نموذج الشراكة",
  footer_link_faq: "الأسئلة الشائعة",
  footer_contact_title: "اتصل بنا",
  footer_email: "البريد الإلكتروني: talktochief@chiefai.com.tr",
  footer_phone: "الهاتف: +90 216 606 22 09",
  footer_office: "المكتب: جامعة البوسفور، تكنوبارك كانديلي – إسطنبول · تركيا",
  footer_privacy: "سياسة الخصوصية",
  footer_terms: "شروط الاستخدام",
  footer_cookies: "سياسة ملفات تعريف الارتباط",
  footer_copyright: "© 2025 Datafors. جميع الحقوق محفوظة.",
  footer_powered: "مدعوم من DataFors",

  // Privacy Policy
  privacy_title: "سياسة الخصوصية",
  privacy_intro:
    "Chief هو مساعد ذكاء اصطناعي تم تطويره بواسطة Datafors. أمان وخصوصية بيانات المستخدمين هي أولويتنا.",
  privacy_collected_title: "البيانات التي يتم جمعها",
  privacy_collected_desc:
    "قد يعالج Chief الفئات التالية من البيانات ضمن نطاق الخدمة:",
  privacy_collected_1: "معلومات الهوية (الاسم واللقب)",
  privacy_collected_2: "معلومات الاتصال (الهاتف، البريد الإلكتروني)",
  privacy_collected_3: "معلومات الشركة (اسم الشركة، المنصب)",
  privacy_collected_4: "بيانات النظام (الجهاز، IP، ملفات الارتباط)",
  privacy_collected_5:
    "البيانات التشغيلية (الطلبات وأوامر العمل والسجلات المُرسلة عبر Chief)",
  privacy_usage_title: "أغراض استخدام البيانات",
  privacy_usage_desc: "تُستخدم البيانات المجمعة للأغراض التالية:",
  privacy_usage_1: "تقديم الخدمات وإدارة سير العمل",
  privacy_usage_2: "الرد على الأسئلة بسرعة",
  privacy_usage_3: "تحسين أداء المنتج",
  privacy_usage_4: "عمليات الأمان والتحقق",
  privacy_usage_suffix: "",
  privacy_sharing_title: "مشاركة البيانات",
  privacy_sharing_desc: "لا تتم مشاركة البيانات إلا في الحالات التالية:",
  privacy_sharing_1: "الالتزامات القانونية",
  privacy_sharing_2: "الأنظمة المتكاملة بموافقة المستخدم",
  privacy_sharing_3: "مزودو البنية التحتية للخدمات",
  privacy_security_title: "أمن البيانات",
  privacy_security_desc: "تُخزن البيانات في:",
  privacy_security_1: "قواعد بيانات مشفرة",
  privacy_security_2: "هياكل وصول مع التحكم في الأذونات",
  privacy_security_suffix: "",
  privacy_retention_title: "مدة الاحتفاظ بالبيانات",
  privacy_retention_desc:
    "تُخزن البيانات طوال فترة تقديم الخدمة أو المدة المطلوبة قانونيًا.",
  privacy_rights_title: "حقوقك",
  privacy_rights_desc: "بموجب قانون KVKK وGDPR، لديك الحق في:",
  privacy_rights_1: "الوصول إلى بياناتك",
  privacy_rights_2: "طلب تصحيحها",
  privacy_rights_3: "طلب حذفها أو نقلها",
  privacy_rights_4: "الاعتراض على معالجتها",
  privacy_rights_suffix: "",
  privacy_contact_title: "للتواصل",
  privacy_contact_desc: "للاستفسارات: privacy@datafors.com",

  // Terms
  terms_title: "شروط الاستخدام",
  terms_intro:
    "باستخدامك لمنصة Chief، فأنت توافق على شروط الاستخدام التالية.",
  terms_service_title: "نطاق الخدمة",
  terms_service_desc:
    "Chief هو مساعد ذكاء اصطناعي يسهل وصول المستخدمين إلى البيانات ويدير سير العمل.",
  terms_obligations_title: "التزامات المستخدم",
  terms_obligations_1: "المستخدم مسؤول عن حماية أمان حسابه.",
  terms_obligations_2: "لا يمكن تقديم طلبات غير قانونية أو ضارة.",
  terms_obligations_3: "المستخدم مسؤول عن دقة البيانات.",
  terms_ip_title: "الملكية الفكرية",
  terms_ip_desc:
    "جميع التصميمات والرموز والنماذج والمواد المرئية التابعة لـ Chief هي ملك لـ Datafors.",
  terms_access_title: "الوصول والتغييرات",
  terms_access_desc:
    "تحتفظ Datafors بالحق في تحسين الخدمة أو تعليقها أو تقييد الوصول إليها.",
  terms_liability_title: "إخلاء المسؤولية",
  terms_liability_desc:
    "الإجراءات التي يقترحها Chief هي إجراءات استشارية. المستخدم مسؤول عن أي نتائج تشغيلية أو تجارية.",
  terms_effective_title: "تاريخ السريان",
  terms_effective_desc: "تسري هذه الشروط اعتبارًا من تاريخ نشرها.",

  // Cookies
  cookies_title: "سياسة ملفات الارتباط",
  cookies_intro:
    "يستخدم موقع Chief وتطبيقه ملفات تعريف الارتباط لتحسين تجربة المستخدم.",
  cookies_types_title: "أنواع ملفات الارتباط المستخدمة",
  cookies_types_1: "ملفات أساسية",
  cookies_types_2: "ملفات الأداء",
  cookies_types_3: "ملفات وظيفية",
  cookies_manage_title: "إدارة ملفات الارتباط",
  cookies_manage_1: "قبول ملفات الارتباط",
  cookies_manage_2: "تقييد ملفات الارتباط",
  cookies_manage_3: "حظر ملفات الارتباط",
  cookies_manage_note:
    "قد لا تعمل بعض الأقسام في حال تعطيل ملفات الارتباط.",
  cookies_legal_title: "الأساس القانوني",
  cookies_legal_desc:
    "يتم استخدام ملفات الارتباط وفقًا لقوانين KVKK وتوجيهات الخصوصية الإلكترونية.",

  // FAQ
  faq_title: "الأسئلة الشائعة",
  faq_subtitle: "ما تحتاج معرفته عن Chief",
  faq_q1: "ما هو Chief؟",
  faq_a1:
    "هو مساعد ذكاء اصطناعي يقرأ بيانات مؤسستك ويجيب على أسئلتك ويدير سير العمل تلقائيًا.",
  faq_q2: "ماذا يفعل Chief؟",
  faq_a2:
    "يحلل البيانات، يوجه أوامر العمل، ويتابع العمليات ويُكملها.",
  faq_q3: "ما الأنظمة التي يعمل معها Chief؟",
  faq_a3:
    "يتكامل مع CRM وERP وSQL وExcel وAPI ومصادر البيانات الأخرى.",
  faq_q4: "على أي المنصات يمكن استخدام Chief؟",
  faq_a4:
    "يمكن استخدامه عبر الويب والهواتف وWhatsApp وروبوتات المحادثة المخصصة.",
  faq_q5: "هل بياناتي آمنة؟",
  faq_a5:
    "نعم، يتم تخزين البيانات مشفرة ولا يمكن الوصول إليها إلا من قبل الأشخاص المصرح لهم.",
  faq_q6: "هل يمكنني طلب عرض تجريبي؟",
  faq_a6: "نعم، يمكنك تقديم طلب عبر نموذج الاتصال أو زر تحدث مع Chief.",
  
  // Partnership
  partnership_hero_title_1: "كن شريكًا",
  partnership_hero_title_2: "مع Chief",
  partnership_hero_desc: "ضع Chief بجانب حلولك وقدم مساعدًا للقرار يعتمد على الذكاء الاصطناعي لعملائك. نما معًا من خلال تقاسم الإيرادات ودعم التكامل والتسويق المشترك.",
  partnership_models_title: "نماذج الشراكة",
  partnership_models_desc: "اختر نموذج الشراكة الذي يناسب نموذج عملك وكن جزءًا من نظام Chief البيئي.",
  partnership_tech_title: "شركاء التكنولوجيا والتكامل",
  partnership_tech_desc: "دمج Chief في ERP و CRM و BI والبرامج المخصصة لديك لتقديم حلول دعم القرار الشاملة لعملائك.",
  partnership_tech_feature_1: "تكامل API و webhook",
  partnership_tech_feature_2: "دعم التوثيق التقني",
  partnership_tech_feature_3: "إدارة نجاح العملاء المشتركة",
  partnership_tech_feature_4: "نموذج تقاسم الإيرادات",
  partnership_consulting_title: "الاستشارات والتحول الرقمي",
  partnership_consulting_desc: "ضع Chief كجزء من مجموعة أدوات معايرك عند إجراء تحليل العمليات أو مشاريع البيانات أو استشارات التحول الرقمي.",
  partnership_consulting_feature_1: "ترخيص قائم على المشروع",
  partnership_consulting_feature_2: "برنامج التدريب والشهادات",
  partnership_consulting_feature_3: "دعم تقني قبل البيع",
  partnership_consulting_feature_4: "فرص التسويق المشترك",
  partnership_saas_title: "SaaS ومالكو المنتجات",
  partnership_saas_desc: "أضف طبقة ذكاء اصطناعي إلى منتجاتك الحالية. يجعل Chief منتجك أذكى من خلال قراءة البيانات والأسئلة والإجابات وتفعيل الإجراءات.",
  partnership_saas_feature_1: "خيارات الحل بدون تسمية",
  partnership_saas_feature_2: "تكامل مدمج",
  partnership_saas_feature_3: "التسعير لكل عميل",
  partnership_saas_feature_4: "دعم التكامل التقني",
  partnership_benefits_title: "فوائد الشراكة",
  partnership_benefits_desc: "القيمة والفرص التي ستحصل عليها كشريك Chief.",
  benefit_revenue_title: "تقاسم الإيرادات",
  benefit_revenue_desc: "معدلات عمولة تنافسية ونموذج إيرادات مستدام",
  benefit_support_title: "الدعم التقني",
  benefit_support_desc: "فريق دعم تقني للتكامل وقبل البيع",
  benefit_marketing_title: "التسويق المشترك",
  benefit_marketing_desc: "حملات التسويق المشترك وإنشاء المحتوى",
  benefit_training_title: "برنامج التدريب",
  benefit_training_desc: "فرص الشهادات والتعليم المستمر",
  benefit_access_title: "الوصول الأولوي",
  benefit_access_desc: "الوصول المبكر إلى الميزات الجديدة واختبار بيتا",
  benefit_community_title: "مجتمع الشركاء",
  benefit_community_desc: "التواصل ومشاركة المعرفة مع الشركاء الآخرين",
  benefit_materials_title: "مواد البيع",
  benefit_materials_desc: "العروض التقديمية والعروض والوثائق الجاهزة",
  benefit_analytics_title: "تتبع الأداء",
  benefit_analytics_desc: "أدوات الإبلاغ والتحليل المفصلة",
  partnership_process_title: "كيفية أن تصبح شريكًا؟",
  partnership_process_desc: "انضم إلى نظام Chief البيئي من خلال عملية تطبيق بسيطة وسريعة.",
  process_step_1_title: "تقدم بطلب",
  process_step_1_desc: "ملء النموذج أو اتصل بنا",
  process_step_2_title: "المراجعة",
  process_step_2_desc: "ستراجع فريقنا طلبك خلال 2-3 أيام عمل",
  process_step_3_title: "الإعداد",
  process_step_3_desc: "أكمل عملية التدريب والتكامل",
  process_step_4_title: "ابدأ",
  process_step_4_desc: "ابدأ بتقديم Chief لعملائك",
  partnership_cta_title: "ابدأ الآن",
  partnership_cta_desc: "اتصل بنا لإنشاء شراكة مع Chief وتقديم حلول تعتمد على الذكاء الاصطناعي لعملائك.",
  partnership_cta_button: "تقدم بطلب للشراكة"
};

export default ar;
